import { createFileRoute, redirect } from '@tanstack/react-router'

type DispatchSearch = {
  drawer?: boolean
  caseId?: string
  customer?: string
  wo?: string
  workOrder?: string
  notification?: string
}

export const Route = createFileRoute('/dispatch')({
  validateSearch: (search: Record<string, unknown>): DispatchSearch => ({
    drawer: search.drawer === true || search.drawer === 'true' ? true : undefined,
    caseId: typeof search.caseId === 'string' ? search.caseId : undefined,
    customer: typeof search.customer === 'string' ? search.customer : undefined,
    wo: typeof search.wo === 'string' ? search.wo : undefined,
    workOrder: typeof search.workOrder === 'string' && /^[0-9a-f-]{36}$/i.test(search.workOrder) ? search.workOrder : undefined,
    notification: typeof search.notification === 'string' && /^[0-9a-f-]{36}$/i.test(search.notification) ? search.notification : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/schedule', search: { ...search, tab: 'pipeline' }, replace: true })
  },
  component: () => null,
})
